<!-- 原文预览组件 -->
<template>
  <div class="previewBox" v-show="visible && row?.url">
    <div class="titleBox d-f justify-b align-c">
      <section>
        <span
          v-for="(item, index) in titleList"
          :key="index"
          :class="[
            titleIndex == index
              ? 'actTitle c-333 m-r-5 c-p'
              : 'c-333 m-r-5 c-p',
          ]"
          @click="changeView(index)"
        >
          {{ item }}
        </span>
        <span
          v-if="titleIndex == 1 && transFileUrl"
          class="c-primary m-r-10 c-p text-underline"
          @click="createFileView"
        >
          译文不正确？点击重新获取最新译文
        </span>
        <span v-if="titleIndex == 1 && transFileUrl">
          译稿生成时间：{{ formatDate(transCreateTime) }}
        </span>
      </section>
      <div>
        <span
          v-show="
            titleIndex == 0 ||
            (titleIndex == 1 && transFileUrl && transType == 2)
          "
        >
          <span class="m-r-10">
            当前页数：
            <span class="c-warning">{{ iframeCurrentNum }}</span>
            /{{ iframeTotalNum }}
          </span>
          <el-button
            v-if="iframeCurrentNum > 1"
            type="primary"
            size="mini"
            plain
            @click="prePage"
          >
            上一页
          </el-button>
          <el-button
            v-if="iframeCurrentNum < iframeTotalNum"
            type="primary"
            size="mini"
            plain
            @click="nextPage"
          >
            下一页
          </el-button>
        </span>
        <el-button class="m-l-10" type="primary" size="mini" @click="close">
          关闭
        </el-button>
      </div>
    </div>
    <section class="t-c p-t-50" v-if="titleIndex == 1 && transFileStatus == 0">
      <el-button type="primary" @click="createFileView">
        点击生成译文预览
      </el-button>
      <div class="c-333 t-c m-t-10">
        点击可生成终稿样式译文预览，译稿还原需要时间，请尽量在句子全部翻译完成后再点击。
      </div>
    </section>
    <section
      class="d-f justify-c align-c t-c p-t-50"
      v-if="titleIndex == 1 && transFileStatus == 1 && !transFileUrl"
    >
      <span>系统正在努力生成质控译稿预览中，请刷新查看</span>
      <i
        class="el-icon-refresh-left c-primary c-p f-s-18"
        @click="getPreviewResult"
      ></i>
    </section>
    <iframe
      v-show="
        titleIndex == 0 || (titleIndex == 1 && transFileUrl && transType == 2)
      "
      class="w-block h-260 b-n"
      name="iframeDom"
      ref="iframeDom"
      :src="iframeUrl"
    ></iframe>
    <iframe
      v-show="titleIndex == 1 && transFileUrl && transType == 1"
      class="w-block h-260 b-n"
      name="iframeDom1"
      ref="iframeDom1"
      :src="iframeUrl1"
    ></iframe>
  </div>
</template>

<script>
import { previewResult, startQcPreviewFile } from '@/api/qc/qcflow';
import { formatDate } from '@/util/date';
export default {
  name: 'DocPreview',
  components: {},
  props: {
    row: {
      type: Object,
      default: {
        url: '',
        pageNo: 1,
        sentenceNo: '',
        fileTotalPageNo: 1,
      },
    },
    visible: {
      type: Boolean,
      default: false,
    },
    peKey: {
      type: String,
    },
  },
  data() {
    return {
      titleList: ['原文预览显示', '译稿预览显示'],
      titleIndex: 0,
      currentUrl: '',
      iframeUrl: '',
      currentSid: null,
      iframeCurrentNum: 0,
      iframeTotalNum: 0,
      loadFlag: false,
      transFileStatus: null,
      transFileUrl: '',
      transCreateTime: null,
      transType: null,
      iframeUrl1: '',
    };
  },
  watch: {
    row(obj) {
      // 清空之前定位句子的背景色
      if (this.currentSid) {
        this.clearFontColor(`.sent-${this.currentSid}`);
      }
      this.currentUrl = obj.url;
      this.iframeUrl = obj.url + obj.pageNo + '.html';
      this.iframeCurrentNum = obj.pageNo;
      this.iframeTotalNum = obj.fileTotalPageNo;
      this.currentSid = obj.sentenceNo;
      this.iframeOnLoad();
    },
    peKey() {
      this.iframeOnLoad();
    },
    titleIndex(index) {
      this.changeView(index);
    },
  },
  methods: {
    formatDate(time) {
      if (time) {
        let date = new Date(parseFloat(time));
        return formatDate(date, 'yyyy-MM-dd hh:mm');
      }
    },
    changeView(index) {
      this.titleIndex = index;
      if (index == 1) {
        this.getPreviewResult();
      } else {
        this.transType = null;
        this.currentUrl = this.row.url;
        this.iframeUrl = this.row.url + this.row.pageNo + '.html';
        this.iframeCurrentNum = this.row.pageNo;
        this.iframeTotalNum = this.row.fileTotalPageNo;
        this.currentSid = this.row.sentenceNo;
        this.iframeOnLoad();
      }
    },

    getPreviewResult() {
      previewResult({
        fileId: this.row.fileId,
        sentNo: this.row.sentenceNo,
      }).then((res) => {
        const data = res.data?.data;
        this.transFileStatus = data?.status;
        this.transFileUrl = data?.url;
        this.transCreateTime = data?.exportTime;
        this.transType = data?.type;
        if (this.transFileUrl) {
          if (data?.type == 2) {
            this.iframeUrl = this.transFileUrl;
            this.iframeCurrentNum = data?.pageNo;
            this.iframeTotalNum = data?.totalPageSize;
          } else {
            this.iframeUrl1 = this.previewUrl + this.transFileUrl;
          }
        }
      });
    },

    createFileView() {
      startQcPreviewFile({
        fileId: this.row.fileId,
      }).then((res) => {
        this.getPreviewResult();
      });
    },

    iframeOnLoad() {
      console.log(this.loadFlag);
      const iframeDom = this.$refs.iframeDom;
      // onload没触发的场景，直接滚动到句子
      if (this.loadFlag) {
        this.scrollIframe(iframeDom);
      } else {
        iframeDom.onload = () => {
          this.loadFlag = true;
          // 句子节点滚动
          this.scrollIframe(iframeDom);
        };
      }
    },
    // 句子节点滚动
    scrollIframe(iframeDom) {
      const sentenceNode = iframeDom.contentWindow.document.querySelector(
        `.sent-${this.row.sentenceNo}`,
      );
      this.addFontColor(`.sent-${this.row.sentenceNo}`);
      // 延时滚动到用户可见视图
      setTimeout(() => {
        sentenceNode?.scrollIntoView({ behavior: 'smooth' });
      }, 150);
    },
    prePage() {
      if (this.iframeCurrentNum > 0) {
        this.iframeUrl =
          this.currentUrl + (this.iframeCurrentNum - 1) + '.html';
        this.iframeCurrentNum = this.iframeCurrentNum - 1;
      }
    },
    nextPage() {
      if (this.iframeCurrentNum < this.iframeTotalNum) {
        this.iframeUrl =
          this.currentUrl + (this.iframeCurrentNum + 1) + '.html';
        this.iframeCurrentNum = this.iframeCurrentNum + 1;
      }
    },
    close() {
      // 清除句子ID，回调关闭预览弹层
      this.clearFontColor(`.sent-${this.currentSid}`);
      this.currentSid = null;
      this.row.previewFlag = false;
      this.titleIndex = 0;
      this.$emit('update:visible', false);
    },
    // 清除所有着色句子的背景色
    clearFontColor(nodeClass) {
      const iframeDom = this.$refs.iframeDom;
      const fontBgNode =
        iframeDom.contentWindow.document.querySelectorAll(nodeClass);
      if (fontBgNode) {
        fontBgNode?.forEach((item) => {
          this.clearActiveStyle(item);
        });
      }
    },
    // 添加着色句子的背景色
    addFontColor(nodeClass) {
      const iframeDom = this.$refs.iframeDom;
      const fontBgNode =
        iframeDom.contentWindow.document.querySelectorAll(nodeClass);
      if (fontBgNode) {
        fontBgNode?.forEach((item) => {
          this.setActiveStyle(item);
        });
      }
    },
    // 不确定解析出来的层级，递归下
    setActiveStyle(node) {
      // 3表示文本，没有style属性
      if (node.nodeType !== 3 && node.style) {
        node.style.background = '#fff0d4';
        node.style.fill = '#14BB8C';
      }

      const childNodes = node?.childNodes;
      childNodes?.forEach((item) => this.setActiveStyle(item));
    },
    clearActiveStyle(node) {
      // 3表示文本，没有style属性
      if (node.nodeType !== 3 && node.style) {
        node.style.background = '';
        node.style.fill = '';
      }
      const childNodes = node?.childNodes;
      childNodes?.forEach((item) => this.clearActiveStyle(item));
    },
  },
};
</script>

<style lang="scss">
.previewBox {
  width: 100%;
  height: 300px;
  border-top: 2px solid #eee;
  background: #fff;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 2200;
  box-sizing: border-box;
  font-size: 14px;
  color: #666;
  .titleBox {
    background: #fff;
    padding: 0 20px 0 30px;
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #eee;
    .actTitle {
      font-weight: 600;
      color: #409eff;
    }
  }
}
</style>
